export const ERoutes = {
	HOME: '/',
	TICKET_HISTORY: '/ticket-history',
	NOTIFICATIONS: '/notifications',
	KNOWLEDGE_BASE: '/knowledge-base',
	PROFILE: '/profile',
	SETTINGS: '/settings',
}
